import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
  Fragment,
} from "react";
import ReactDOM from "react-dom";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import sanityClient from "../../client.js";
import "./frontpage.styles.scss";
import Menu from "../../components/menu/menu.component";
import { useMediaQuery } from "react-responsive";

// import styled from "styled-components";
// import { Controller, Scene } from "react-scrollmagic";
// // import { gsap } from "gsap";
// import { Controls, PlayState, Timeline, Tween } from "react-gsap";

import { PortableText } from "@portabletext/react";
import SanityMuxPlayer from "sanity-mux-player";
import imageUrlBuilder from "@sanity/image-url";

// import { Navigation, Pagination} from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import { MouseContext } from "../../context/mouse-context";
// import SlideshowCursor from "../../components/slideshowCursor/slideshowCursor.component";

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  return builder.image(source);
}

import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// Prøv å stoppe scroll programmatisk, se om det gir effekt. Evt. scrolltrigger-eksempelet

const Frontpage = ({ frontpageContent, currentPage, canAccess }) => {
  const [pageSizeSettings, setPageSizeSettings] = useState({});
  const [showMenuTitle, setShowMenuTitle] = useState(false);
  const { cursorChangeHandler } = useContext(MouseContext);
  const [swiperDirection, setSwiperDirection] = useState("");
  const [firstSlideState, setFirstSlideState] = useState("");
  const isNarrow = useMediaQuery({ query: "(max-width: 1000px)" });
  const [swiper, setSwiper] = useState(null);

  let navigate = useNavigate();

  const returnImageWidth = () => {
    return window.innerWidth;
  };

  const projectClickHandler = (slug) => {
    navigate(`/${slug}`);
  };

  useEffect(() => {
    if (currentPage == null && swiper !== null) {
      swiper.slideTo(1);
    }
  }, [currentPage]);

  if (frontpageContent == null) return <></>;
  return (
    <div
      className={`frontpage ${isNarrow ? "narrow" : "full-size"} ${
        currentPage ? "no-scroll" : ""
      }`}
    >
      <div className={`opening-slide ${firstSlideState}`}>
        <div className="opening-slide-title title-font">Harriet Sprattland</div>
        <div className="opening-slide-title-background title-font">
          Harriet Sprattland
        </div>

        <div className="opening-slide-subtitle title-font">
          Art and Creative Director based in Berlin
        </div>

        <div className="image-wrapper-left">
          <img
            onClick={() =>
              projectClickHandler(frontpageContent.projects[0].slug.current)
            }
            onMouseEnter={() => cursorChangeHandler("active")}
            onMouseLeave={() => cursorChangeHandler("")}
            src={urlFor(frontpageContent.projects[0].highlightImageLeft)
              .width(returnImageWidth())
              .url()}
          />
        </div>

        <div className="image-wrapper-right">
          <img
            onClick={() =>
              projectClickHandler(frontpageContent.projects[0].slug.current)
            }
            onMouseEnter={() => cursorChangeHandler("active")}
            onMouseLeave={() => cursorChangeHandler("")}
            src={urlFor(frontpageContent.projects[0].highlightImageRight)
              .width(returnImageWidth())
              .url()}
          />
        </div>
      </div>
      <Swiper
        onSwiper={(s) => {
          setSwiper(s);
        }}
        speed={700}
        direction={"vertical"}
        mousewheel={{ thresholdDelta: 20 }}
        allowSlideNext={canAccess}
        allowTouchMove={isNarrow}
        modules={[Mousewheel]}
        className="mySwiper"
        onSlideNextTransitionStart={(el) => {
          if (el.realIndex == 1 && el.previousIndex == 0) {
            setFirstSlideState("fadeOut");
          }
          // console.log('down')
          setSwiperDirection("down");
        }}
        onSlidePrevTransitionStart={(el) => {
          console.log(el);
          if (el.realIndex == 0 && el.previousIndex == 1) {
            setFirstSlideState("fadeIn");
          }
          // console.log('up')
          setSwiperDirection("up");
        }}
      >
        {frontpageContent.projects.map((project, index, array) => {
          return (
            <div key={999}>
              {index == 0 ? (
                <>
                  <SwiperSlide key={"first"}></SwiperSlide>
                  <SwiperSlide key={project._id}>
                    {({ isActive, isNext, isPrev }) => (
                      <div
                        className={`slider-content ${
                          swiperDirection == "up" && isActive
                            ? "transition-up"
                            : swiperDirection == "down" && isActive
                            ? "transition-down"
                            : isNext
                            ? "slide-next"
                            : isPrev
                            ? "slide-prev"
                            : ""
                        }`}
                      >
                        <div
                          onClick={() =>
                            projectClickHandler(project.slug.current)
                          }
                          onMouseEnter={() => cursorChangeHandler("active")}
                          onMouseLeave={() => cursorChangeHandler("")}
                          className="slider-project-title title-font"
                        >
                          {project.title}
                        </div>

                        <div className="image-wrapper-left">
                          <img
                            onClick={() =>
                              projectClickHandler(project.slug.current)
                            }
                            onMouseEnter={() => cursorChangeHandler("active")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            src={urlFor(project.highlightImageLeft)
                              .width(window.innerHeight)
                              .url()}
                          />
                        </div>

                        <div className="image-wrapper-right">
                          <img
                            onClick={() =>
                              projectClickHandler(project.slug.current)
                            }
                            onMouseEnter={() => cursorChangeHandler("active")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            src={urlFor(project.highlightImageRight)
                              .width(window.innerHeight)
                              .url()}
                          />
                        </div>
                      </div>
                    )}
                  </SwiperSlide>
                </>
              ) : index == array.length - 1 ? (
                <>
                  <SwiperSlide key={project._id}>
                    {({ isActive, isNext, isPrev }) => (
                      <div
                        className={`slider-content ${
                          swiperDirection == "up" && isActive
                            ? "transition-up"
                            : swiperDirection == "down" && isActive
                            ? "transition-down"
                            : isNext
                            ? "slide-next"
                            : isPrev
                            ? "slide-prev"
                            : ""
                        }`}
                      >
                        <div
                          onClick={() =>
                            projectClickHandler(
                              frontpageContent.projects[
                                frontpageContent.projects.length - 1
                              ].slug.current
                            )
                          }
                          onMouseEnter={() => cursorChangeHandler("active")}
                          onMouseLeave={() => cursorChangeHandler("")}
                          className="slider-project-title title-font"
                        >
                          {
                            frontpageContent.projects[
                              frontpageContent.projects.length - 1
                            ].title
                          }
                        </div>

                        <div className="image-wrapper-left">
                          <img
                            onClick={() =>
                              projectClickHandler(
                                frontpageContent.projects[
                                  frontpageContent.projects.length - 1
                                ].slug.current
                              )
                            }
                            onMouseEnter={() => cursorChangeHandler("active")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            src={urlFor(
                              frontpageContent.projects[
                                frontpageContent.projects.length - 1
                              ].highlightImageLeft
                            )
                              .width(returnImageWidth())
                              .url()}
                          />
                        </div>

                        <div className="image-wrapper-right">
                          <img
                            onClick={() =>
                              projectClickHandler(
                                frontpageContent.projects[
                                  frontpageContent.projects.length - 1
                                ].slug.current
                              )
                            }
                            onMouseEnter={() => cursorChangeHandler("active")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            src={urlFor(
                              frontpageContent.projects[
                                frontpageContent.projects.length - 1
                              ].highlightImageRight
                            )
                              .width(returnImageWidth())
                              .url()}
                          />
                        </div>
                      </div>
                    )}
                  </SwiperSlide>
                  <SwiperSlide key={index}>
                    <div className="bottom-section title-font">
                      <a
                        onMouseEnter={() => cursorChangeHandler("active")}
                        onMouseLeave={() => cursorChangeHandler("")}
                        href="mailto:sprattharriet@gmail.com"
                      >
                        Get in touch
                      </a>
                    </div>
                  </SwiperSlide>
                </>
              ) : (
                <SwiperSlide key={project._id}>
                  {({ isActive, isNext, isPrev }) => (
                    <div
                      className={`slider-content ${
                        swiperDirection == "up" && isActive
                          ? "transition-up"
                          : swiperDirection == "down" && isActive
                          ? "transition-down"
                          : isNext
                          ? "slide-next"
                          : isPrev
                          ? "slide-prev"
                          : ""
                      }`}
                    >
                      <div
                        onClick={() =>
                          projectClickHandler(project.slug.current)
                        }
                        onMouseEnter={() => cursorChangeHandler("active")}
                        onMouseLeave={() => cursorChangeHandler("")}
                        className="slider-project-title title-font"
                      >
                        {project.title}
                      </div>

                      <div className="image-wrapper-left">
                        <img
                          onClick={() =>
                            projectClickHandler(project.slug.current)
                          }
                          onMouseEnter={() => cursorChangeHandler("active")}
                          onMouseLeave={() => cursorChangeHandler("")}
                          src={urlFor(project.highlightImageLeft)
                            .width(returnImageWidth())
                            .url()}
                        />
                      </div>

                      <div className="image-wrapper-right">
                        <img
                          onClick={() =>
                            projectClickHandler(project.slug.current)
                          }
                          onMouseEnter={() => cursorChangeHandler("active")}
                          onMouseLeave={() => cursorChangeHandler("")}
                          src={urlFor(project.highlightImageRight)
                            .width(returnImageWidth())
                            .url()}
                        />
                      </div>
                    </div>
                  )}
                </SwiperSlide>
              )}
            </div>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Frontpage;
